import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const ACCOUNT_TYPES = [
  { label: "Expense", value: "expense" },
  { label: "Purchase", value: "purchase" },
  { label: "Asset", value: "asset" },
  { label: "Liability", value: "liability" },
  { label: "Income", value: "income" },
  { label: "Capital", value: "capital" },
  { label: "Bank", value: "bank" },

  { label: "Salary", value: "salary" },
  { label: "Rent", value: "rent" },
  { label: "Loan", value: "loan" },
  { label: "Interest", value: "interest" },
  { label: "GST", value: "gst" },
  { label: "Commission", value: "commission" },
  { label: "Drawings", value: "drawings" },

  { label: "Custom", value: "custom" }
];

const RecordExpenses = () => {
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem("userEmail");

  const [file, setFile] = useState(null);
  const [total, setTotal] = useState(null);
  const [folderName, setFolderName] = useState("");
  const [gdriveLink, setGdriveLink] = useState("");
  const [gdriveStatus, setGdriveStatus] = useState("");
  const [accountType, setAccountType] = useState("expense");

  const [customDebit, setCustomDebit] = useState("");
  const [customCredit, setCustomCredit] = useState("");
  const [loading, setLoading] = useState(false);
  
  const [companyName, setCompanyName] = useState("");
  const [suggestedType, setSuggestedType] = useState("");

  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  useEffect(() => {
    fetch("https://www.d-rosa.ai/appname")
      .then(res => res.json())
      .then(d => setFolderName(d.foldername || "default"));
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setTotal(null);
    setGdriveStatus("");
  };

  const submitInvoice = async () => {
    if (!file) return alert("Upload invoice");
    if (!gdriveLink) return alert("Google Drive link required");

    if (accountType === "custom" && (!customDebit || !customCredit)) {
      return alert("Enter both Debit and Credit accounts");
    }

    setLoading(true);

    try {
      const localFd = new FormData();
      localFd.append("image", file);
      localFd.append(
        "path",
        `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`
      );

      await fetch("https://www.d-rosa.ai/IMGAPI", {
        method: "POST",
        body: localFd
      });

      const gdFd = new FormData();
      gdFd.append("image", file);
      gdFd.append("driveLink", gdriveLink);

      await fetch("https://www.d-rosa.ai/GDriveUpload", {
        method: "POST",
        body: gdFd
      });

      setGdriveStatus("Uploaded to Google Drive");

      const ocrFd = new FormData();
      ocrFd.append("file", file);

      const res = await fetch("https://www.d-rosa.ai/extract-gst", {
        method: "POST",
        body: ocrFd
      });

      const data = await res.json();

      if (data.success) {
        if (data.total_amount) setTotal(data.total_amount);
        if (data.company_name) setCompanyName(data.company_name);

        if (data.suggested_type && accountType !== "custom") {
          setAccountType(data.suggested_type);
          setSuggestedType(data.suggested_type);
        }

        const jf = new FormData();
        jf.append("driveLink", gdriveLink);
        jf.append("amount", data.total_amount);

        if (accountType !== "custom") {
          jf.append("type", data.suggested_type || accountType);
        } else {
          jf.append("type", "expense");
          jf.append("overrideDebit", customDebit);
          jf.append("overrideCredit", customCredit);
        }

        await fetch("https://www.d-rosa.ai/update-journal", {
          method: "POST",
          body: jf
        });
      }

    } catch (err) {
      alert("Server error");
    }

    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 500, margin: "auto", padding: 20 }}>
      
      {/* Dark Blue Signed In */}
      <h3 style={{ color: "#003366" }}>Signed in as</h3>
      <b style={{ color: "#003366" }}>{userEmail}</b>

      {/* Dark Pink Title */}
      <h2 style={{ color: "#C2185B" }}>Record Journal Entry</h2>

      <input type="file" onChange={handleFileChange} />

      <input
        placeholder="Google Drive Folder Link"
        value={gdriveLink}
        onChange={e => setGdriveLink(e.target.value)}
      />

      <select value={accountType} onChange={e => setAccountType(e.target.value)}>
        {ACCOUNT_TYPES.map(a => (
          <option key={a.value} value={a.value}>{a.label}</option>
        ))}
      </select>

      {accountType === "custom" && (
        <>
          <input
            placeholder="Debit Account"
            value={customDebit}
            onChange={e => setCustomDebit(e.target.value)}
          />
          <input
            placeholder="Credit Account"
            value={customCredit}
            onChange={e => setCustomCredit(e.target.value)}
          />
        </>
      )}

      <button onClick={submitInvoice}>Upload & Process</button>

      {loading && <p>Processing...</p>}
      {gdriveStatus && <p>{gdriveStatus}</p>}
      {total && <p><b>Amount:</b> ?{total}</p>}
      {companyName && <p><b>Vendor:</b> {companyName}</p>}
      {suggestedType && <p><b>Detected Type:</b> {suggestedType.toUpperCase()}</p>}

      {/* Back Button at Bottom */}
      <div style={{ marginTop: 30, textAlign: "center" }}>
        <button onClick={() => navigate(-1)}>
          <img src={backButton} alt="Back" width="60" />
        </button>
      </div>

    </div>
  );
};

export default RecordExpenses;